export default {
  data() {
    return {
      dateEquipTypes: ['xm', 'pds', 'byq'],
      periodEquipTypes: ['jx', 'cx'],
    };
  },
  methods: {
    isDateOfEquip(equipType, isDateSelector) {
      return (isDateSelector && this.dateEquipTypes.indexOf(equipType) >= 0)
      || (!isDateSelector && this.periodEquipTypes.indexOf(equipType) >= 0);
    },
    isDateSelectorChange(newVal, oldVal) {
      let isChanged = false;
      if (oldVal !== null) {
        if (
          (newVal.oType === 'cx' || newVal.oType === 'jx')
          && oldVal.oType !== 'cx'
          && oldVal.oType !== 'jx'
        ) {
          isChanged = true;
        } else if (
          newVal.oType !== 'cx'
            && newVal.oType !== 'jx'
            && (oldVal.oType === 'cx' || oldVal.oType === 'jx')
        ) {
          isChanged = true;
        }
      }
      return isChanged;
    },
  },
};
